























import { Nullable, SerialNumber } from '@/types';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  props: {
    item: Object as PropType<SerialNumber>,
    index: Number,
    items: {
      type: Array as PropType<SerialNumber[]>,
      default: () => [],
    },
    patterns: { type: Array as PropType<string[]>, default: () => ['(.*?)'] },
  },

  computed: {
    isValidSerialnumber(): boolean {
      return this.patterns.some(
        (pattern: string) =>
          this.item.serialNumber && this.item.serialNumber.match(new RegExp(pattern)),
      );
    },

    hasDuplicate(): boolean {
      if (!this.item.serialNumber) return false;

      const itemIndex = this.items.indexOf(this.item);

      const dupeIndex = this.items.findIndex(
        (val, index) => val.serialNumber === this.item.serialNumber && index !== itemIndex,
      );

      return dupeIndex >= 0;
    },

    icon() {
      switch (this.item.source) {
        case 'scan':
          return 'mdi-barcode-scan';
        default:
          return 'mdi-keyboard-outline';
      }
    },
  },
});
